export default {
  title: 'Grupa treningowa',
  type: 'object',
  properties: {
    name: {
      title: 'schema.team.name',
      type: 'string',
      fieldRequired: true
    },
    clubId: {
      title: 'schema.team.clubId',
      type: 'number',
      fieldRequired: true
    },
    sportId: {
      title: 'schema.team.sportId',
      type: 'number',
      fieldRequired: true
    }
  }
};
